import { css } from 'styled-components';
import memoize from 'lodash.memoize';

var Breakpoints = {
  UltraWideScreen: 1352,
  WideScreen: 1184,
  Desktop: 960,
  Tablet: 768,
  Mobile: 480
}; // use em in breakpoints to work properly cross-browser and support users
// changing their browsers font-size: https://zellwk.com/blog/media-query-units/

var getWidth = memoize(function (breakpoint) {
  return "".concat(breakpoint / 16, "em");
});
var MEDIA_QUERY_STRINGS = {
  // Enforces Desktop first responsive behavior.
  UltraWideScreen: "(max-width: ".concat(getWidth(Breakpoints.UltraWideScreen), ")"),
  WideScreen: "(max-width: ".concat(getWidth(Breakpoints.WideScreen), ")"),
  Desktop: "(max-width: ".concat(getWidth(Breakpoints.Desktop), ")"),
  Tablet: "(max-width: ".concat(getWidth(Breakpoints.Tablet), ")"),
  Mobile: "(max-width: ".concat(getWidth(Breakpoints.Mobile), ")"),
  // Most of the cases, following stricter media queries won't be needed, but this will ease
  // the migration to css media query from `MediaQuery`component. Device specific breakpoints
  // is not recommended, however, this will be much handy in some rare cases.
  MobileOnly: "(max-width: ".concat(getWidth(Breakpoints.Mobile), ")"),
  TabletOnly: "(min-width: ".concat(getWidth(Breakpoints.Tablet), ") and (max-width: ").concat(getWidth(Breakpoints.Desktop - 1), ")"),
  DesktopOnly: "(min-width: ".concat(getWidth(Breakpoints.Desktop), ") and (max-width: ").concat(getWidth(Breakpoints.WideScreen - 1), ")"),
  WideScreenOnly: "(min-width: ".concat(getWidth(Breakpoints.WideScreen), ") and (max-width: ").concat(getWidth(Breakpoints.UltraWideScreen - 1), ")"),
  UltraWideScreenOnly: "(min-width: ".concat(getWidth(Breakpoints.UltraWideScreen), ")"),
  MobileOrTabletOnly: "(max-width: ".concat(getWidth(Breakpoints.Desktop - 1), ")"),
  TabletOrDesktopOnly: "(min-width: ".concat(getWidth(Breakpoints.Tablet), ") and (max-width: ").concat(getWidth(Breakpoints.WideScreen - 1), ")"),
  TabletOrBigger: "(min-width: ".concat(getWidth(Breakpoints.Tablet), ")"),
  DesktopOrBigger: "(min-width: ".concat(getWidth(Breakpoints.Desktop), ")"),
  WideScreenOrBigger: "(min-width: ".concat(getWidth(Breakpoints.WideScreen), ")")
};

var generateMediaQuery = function generateMediaQuery(mediaQueryString) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    /* eslint-disable prefer-spread */
    return css(["@media ", "{", ";}"], mediaQueryString, css.apply(null, args));
    /* eslint-enable prefer-spread */
  };
};

// iterate through the sizes and create a media template
var mediaQueryStringsKeys = Object.keys(MEDIA_QUERY_STRINGS);
var Media = mediaQueryStringsKeys.reduce(function (accumulator, deviceType) {
  accumulator[deviceType] = generateMediaQuery(MEDIA_QUERY_STRINGS[deviceType]);
  return accumulator;
}, {});

export { Breakpoints, Media, getWidth };
